import { render, staticRenderFns } from "./POLLINGCENTER.vue?vue&type=template&id=e53a9ed4&scoped=true&lang=pug"
import script from "./POLLINGCENTER.vue?vue&type=script&lang=js"
export * from "./POLLINGCENTER.vue?vue&type=script&lang=js"
import style0 from "./POLLINGCENTER.vue?vue&type=style&index=0&id=e53a9ed4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53a9ed4",
  null
  
)

export default component.exports